import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=28c26fe9&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=28c26fe9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c26fe9",
  null
  
)

export default component.exports